module.exports = __webpack_public_path__ + "static/media/7 Minuts  06th May 2022.1ee7d1b5.pdf";